<ng-container *ngIf="membership.unlinked_customers.length > 0">
  <div class="alert alert-info">
    This membership has outstanding unlinked members. Link those members before modifying the membership.
  </div>
</ng-container>

<ng-container *ngIf="membership.unlinked_customers.length === 0">
  <div class="alert alert-info">
    The membership's members will be changed effective immediately. No prorated charges or refunds will occur, but the membership's price will reflect the new set of members when the next bill occurs.
  </div>

  <label>Members</label>
  <ul class="mb-1">
    <li *ngFor="let member of members; index as i;">
      {{ member.first_name }} {{ member.last_name }}
      <span *ngIf="member.is_individually_frozen">(frozen)</span>
      -
      <a class="link-danger" href="#" (click)="members.splice(i, 1); $event.preventDefault();">
        Remove
      </a>
    </li>
    <li *ngIf="members.length === 0" class="text-muted">(none)</li>
  </ul>

  <button class="btn btn-sm btn-outline-primary mb-0"
          type="button"
          (click)="openAddMemberModal()">
    Add Member
  </button>
</ng-container>

<div class="alert alert-danger mt-3 mb-0" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
